module.exports = __webpack_public_path__ + "static/media/surveyBanner.cac5a22b.svg";